module.exports = __webpack_public_path__ + "img/ubm-pc4.b5a583b8.png";